export const CodeInputTestIdFactory = {
    // bases, can be used for regex matching in playwright getbytestid
    getCodeInputBase: () => 'code',
    // testid generators
    getCodeInputGroupTestId: (testId) => `${CodeInputTestIdFactory.getCodeInputBase()}-${testId}`,
    getCodeInputDigitTestId: (testId, position) => `${testId}-${CodeInputTestIdFactory.getCodeInputBase()}-${position}`,
};
